import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-down\"><title>down</title><path d=\"M13.16 5.717a.85.85 0 0 0-.849-.865.877.877 0 0 0-.88.865V16.62l-.952-.968a.865.865 0 1 0-1.223 1.223L11.7 19.32c.17.17.39.254.612.252a.862.862 0 0 0 .613-.254l2.441-2.441a.865.865 0 1 0-1.223-1.223l-.967.967-.016-10.903z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol